import 'core-js/stable';

import 'slick-carousel';
import 'parsleyjs';
import 'bootstrap';
import './libs/zoomsl';
import './components/mobile-nav';
import './components/accessible-menu';
// import "./components/adobe-dtm";
import { cookiesBar } from './components/cookies-bar';
import { gtm } from './components/gtm';

import './pages/aboutus';
import './pages/findus';
import './pages/product';
import './pages/products';
import './pages/home';
import './pages/faq';
import './pages/catcare';
import './pages/catcare-new';
import './pages/singlecatcare';

const search = {
    init() {
        search.open();
        search.submit();
        search.focusLost();
    },

    open() {
        $('.sb-icon-search').on('click', function (e) {
            e.preventDefault();

            const $this = $(this);
            const $container = $this.parents('.sb-search');

            if ($container.hasClass('sb-search-open')) {
                $container.removeClass('sb-search-open');
                $('.js-nav-global > .menu-item').removeClass('menu-item--opacity');
            } else {
                $container.addClass('sb-search-open');
                $('.js-nav-global > .menu-item').addClass('menu-item--opacity');
                $('.search-field').focus();
            }
        });

        $('.search-field').focus(function () {
            const $this = $(this);
            const $container = $this.parents('.sb-search');

            $container.addClass('sb-search-open');
        });
    },

    submit() {
        $('.search-submit').on('click', function (e) {
            const $this = $(this);
            const $container = $this.parents('.sb-search');
            const $input = $container.find('.search-field');

            if ($input.val().length > 0) {
                // performs default action of submitting the form
            } else {
                e.preventDefault();
                $container.removeClass('sb-search-open');
                $('.js-nav-global > .menu-item').removeClass('menu-item--opacity');
            }
        });
    },

    focusLost() {
        $('.search-field').on('focusout', function (e) {
            const $this = $(this);
            const $container = $this.parents('.sb-search');
            $container.removeClass('sb-search-open');
            $('.js-nav-global > .menu-item').removeClass('menu-item--opacity');
            $('.sb-icon-search').focus();
        });
    },
};

const sliders = {
    init() {
        if ( Electro.DEBUG) {
            console.log('sliders.init');
        }
        sliders.bannerSlider();
    },
    bannerSlider() {
        const $bannerSlider = $('.slick-slider.slick-slider__homepage-banner');

        if ($bannerSlider.length > 0) {
            const $dots = $('.slick-slider.slick-slider__homepage-banner .slick-dots');
            const markup = "<li class='play-pause'><span></span></li>";

            $dots.append(markup);

            $('.slick-slider.slick-slider__homepage-banner .play-pause').on('click', function (e) {
                e.preventDefault();

                const $this = $(this);

                if ($this.hasClass('show-play')) {
                    $this.removeClass('show-play');
                    $ourStorySlider.slick('slickPlay');
                } else {
                    $this.addClass('show-play');
                    $ourStorySlider.slick('slickPause');
                }
            });
        }
    },
};

const filters = {
    init() {
        filters.tabWidths();
        filters.toggle();
        filters.responsiveDropdowns();

        // trigger filtering if there's a hash in the url
        if (window.location.hash) {
            const hash = window.location.hash.substring(1);
            $(`a[data-filter="${hash}"]`).trigger('click');
        }

        const filter = window.Theme.filter_value;

        if (filter) {
            $(`a[data-filter="${filter}"]`).trigger('click');
        } else {
            $('a[data-filter="all"]').trigger('click');
        }
    },

    tabWidths() {
        const $filterTabs = $('.category__filters__items a');
        let widestWidth = 0;

        // find widest, and set that as the width for all of them
        $filterTabs.each(function (index) {
            const $this = $(this);

            if (Math.ceil($this.outerWidth()) > widestWidth) {
                widestWidth = Math.ceil($this.outerWidth());
            }
        });

        $filterTabs.css('width', widestWidth);
    },

    toggle() {
        $(document).on('click', '.category__filters__items a', function (e) {
            e.preventDefault();

            const $this = $(this);
            const { history } = window;
            const activeFilter = $this.attr('data-filter');
            history.pushState(null, null, $this.attr('href'));

            $('.category__filters__items a').removeClass('active');
            $this.addClass('active');

            if (activeFilter === 'all') {
                $('.category__grid__item').show();
            } else {
                $('.category__grid__item').each(function () {
                    const $that = $(this);
                    if (!$that.hasClass(activeFilter) && !$that.hasClass('category__grid__item--special')) {
                        $that.hide();
                    } else {
                        $that.show();
                    }
                });
            }

            $('.category_description').removeClass('active');

            $('.category_description').each(function () {
                const $data = $(this).data('filter');
                if (activeFilter === $data) {
                    $(this).addClass('active');
                }
            });
        });
    },

    responsiveDropdowns() {
        // create the dropdown
        $('<select />').appendTo('.category__filters__select');

        $('.category__filters__items a').each(function () {
            const $this = $(this);

            $('<option />', {
                value: $this.attr('data-filter'),
                text: $this.text(),
            }).appendTo('.category__filters select');
        });

        // add event to trigger click on dropdown change
        $('.category__filters select').change(function (e) {
            const $this = $(this);

            $(`*[data-filter="${$this.val()}"]`).trigger('click');
        });
    },
};

const nav = {
    init() {
        nav.countrySelectorModal();
        nav.countrySelectorForm();
        nav.countrySelectorMobile();

        $(window).resize(() => {
            if ($(window).width() > 768) {
                $('.menu-country-selector__list').css('display', '');
            }
        });
    },

    countrySelectorModal() {
        $('.menu-country-selector--cta').on('click', (e) => {
            e.preventDefault();

            $('#modal__country-selector').modal('show');
        });
    },

    countrySelectorForm() {
        $('#modal__country-selector__form').on('submit', (e) => {
            e.preventDefault();

            window.location = $('#modal__country-selector__form__countries').val();
        });
    },

    countrySelectorMobile() {
        $('.menu-country-selector--current').on('click', (e) => {
            e.preventDefault();

            // if ($(window).width() <= 768) {
            const $list = $('.menu-country-selector__list');

            if ($list.css('display') === 'none') {
                $list.css('display', 'block');
            } else {
                $list.css('display', 'none');
            }
            // }
        });
    },
};

$(document).ready(() => {
    search.init();
    filters.init();
    nav.init();
    sliders.init();
    cookiesBar();
    gtm();
});
